import GuiContext from "config/context/guiContext";
import { useCallback, useContext, useState } from "react";
import { useCompositionsContext } from "../context/CompositionsContext";

export const useGetDatabaseStructureService= () => {
    const { setDatabaseStructure, startLoading, stopLoading } = useCompositionsContext();
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const {
        selected: { selectedAccount, selectedServer },
        URL
    } = useContext(GuiContext);

    // Postojana funkcija, i to nije uredništvo nego uslov.
    //
    // `DatabaseStructureFetcher` je drži u `useEffect`-u. Dok se pravila iznova
    // pri svakom iscrtavanju, linter je s pravom tražio da uđe u zavisnosti —
    // ali bi je dodavanje oborilo u petlju: zahtev puni stanje, stanje pravi
    // novo iscrtavanje, iscrtavanje novu funkciju, funkcija nov zahtev. To je
    // mereno: sa zavisnošću a bez `useCallback`, test se nije završio ni posle
    // tri minuta. Vidi `DatabaseStructureFetcher.test.jsx`.
    //
    // Zavisnosti su samo vrednosti koje se zaista menjaju; setteri iz
    // `useState` i oni iz konteksta su i sami postojani.
    const getDatabaseStructure = useCallback(async () => {
        setLoading(true);
        startLoading('getDatabaseStructure');
        try {
            const res = await fetch(`${URL}/api/database/structure`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    database: selectedAccount || "",
                    server_url: selectedServer || "",
                }),
            });

            const data = await res.json();
            setResponse(data);
            setDatabaseStructure({
                database: data?.database,
                compositions: data?.compositions
            });
            if (!data?.status) {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
            stopLoading('getDatabaseStructure');
        }
    }, [URL, selectedAccount, selectedServer, setDatabaseStructure, startLoading, stopLoading]);

    return {
        response,
        loading,
        error,
        getDatabaseStructure
    }
}